import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import type { ControlListResponse } from '../../interfaces/control-list-response'
import { EVENT_NAMES } from '../../utils/events'

@Component({
  selector: 'app-control-list-layout',
  templateUrl: './control-list-layout.component.html',
  styleUrls: ['./control-list-layout.component.scss'],
})
export class ControlListLayoutComponent implements OnInit, OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(private router: Router, private route: ActivatedRoute) {}

  private handleOnValidateUrl = (event: Event) => {
    const { detail } = event as CustomEvent<ControlListResponse>
    if (detail?.error) return
    else if ('success' in detail.data && detail.data.success) {
      const flow = this.router.url.split('/')[1]
      if (flow === 'flexible')
        this.router.navigate(['..', 'simulacion'], { relativeTo: this.route, replaceUrl: true })
      else this.router.navigate(['..', 'firc'], { relativeTo: this.route, replaceUrl: true })
    }
  }

  private handleOnBlocked = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  private redirectToAgency = () => {
    window.open('https://www.pichincha.com/portal/geolocalizacion', '_blank')
  }

  ngOnInit(): void {
    this.storage.set(EVENT_NAMES.controlListConfig, { config: 'config' })
    window.addEventListener(EVENT_NAMES.controlListOnValidateUrl, this.handleOnValidateUrl)
    window.addEventListener(EVENT_NAMES.controlListOnBlocked, this.handleOnBlocked)
    window.addEventListener(EVENT_NAMES.controlListOnRedirectToAgency, this.redirectToAgency)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.controlListOnValidateUrl, this.handleOnValidateUrl)
    window.removeEventListener(EVENT_NAMES.controlListOnBlocked, this.handleOnBlocked)
    window.removeEventListener(EVENT_NAMES.controlListOnRedirectToAgency, this.redirectToAgency)
  }
}
